(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/freja/freja-main.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/freja/freja-main.js');

'use strict';

const _React = React,
  useEffect = _React.useEffect;
const FrejaStart = svs.iam_idp.components.freja.FrejaStart;
const _svs$iam_idp$componen = svs.iam_idp.components.shared,
  PollingMobile = _svs$iam_idp$componen.PollingMobile,
  PollingDesktop = _svs$iam_idp$componen.PollingDesktop,
  Loading = _svs$iam_idp$componen.Loading;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const _svs$iam_idp$atoms = svs.iam_idp.atoms,
  isPollingAtom = _svs$iam_idp$atoms.isPollingAtom,
  isNewCustomerAtom = _svs$iam_idp$atoms.isNewCustomerAtom,
  loginCompletedAtom = _svs$iam_idp$atoms.loginCompletedAtom;
const login = svs.iam_idp.utils.Login;
const FrejaMain = _ref => {
  let showQR = _ref.showQR;
  const isPolling = useAtomValue(isPollingAtom);
  const isNewCustomer = useAtomValue(isNewCustomerAtom);
  const loginCompleted = useAtomValue(loginCompletedAtom);
  const PollingComponent = showQR ? PollingDesktop : PollingMobile;
  useEffect(() => {
    if (showQR && !loginCompleted) {
      login.start(isNewCustomer);
    }
  }, [showQR, isNewCustomer, loginCompleted]);
  if (loginCompleted) {
    return React.createElement(Loading, null);
  }
  return isPolling && !showQR ? React.createElement(PollingComponent, null) : React.createElement(FrejaStart, {
    isNewCustomer: isNewCustomer,
    showQR: showQR
  });
};
svs.iam_idp.components.freja.FrejaMain = FrejaMain;

 })(window);